export default class {
    constructor(financeProduct) {
        this.financeProduct = financeProduct;
        this.error = this.hasError();
    }

    getErrorMessage(techincal = false) {
        if (this.financeProduct == false) {
            return 'Unable to generate a quote';
        }
        if (typeof this.financeProduct.HasError == 'undefined') {
            return 'Unable to generate a quote';
        }
        if (this.financeProduct.HasError == true) {
            if (techincal && this.financeProduct.Error.TechnicalMessage !== 'undefined') {
                return this.financeProduct.Error.TechnicalMessage;
            }

            if (typeof this.financeProduct.Error.DealerMessage !== 'undefined') {
                return this.financeProduct.Error.DealerMessage;
            }

            return 'An error has occurred';
        }
        return 'Unable to generate a quote';
    }

    getNotifications() {
        const notifications = this.financeProduct.Notifications.Public || [];
        let n = [];
        notifications.forEach(notification => {
            if ((typeof notification.Code  == 'undefined' || notification.Code != "33") && typeof notification.Message !== 'undefined') {
                n.push(notification.Message);
            }
        })
        return n;
    }

    hasError() {
        if (this.financeProduct == false) {
            return true;
        }
        if (typeof this.financeProduct.HasError == 'undefined') {
            return true;
        }
        if (this.financeProduct.HasError == true) {
            return true;
        }
        if (typeof this.financeProduct.Quote == 'undefined') {
            return true;
        }
        if (typeof this.financeProduct.Quote.AllInclusiveRegularPayment == 'undefined') {
            return true;
        }
        return false;
    }

    getKey() {
        const key = this.financeProduct.Key || '';
        return key;
    }

    getLender() {
        if (this.error) {
            return false;
        }
        return this.financeProduct.Product.Lender;
    }

    getMonthlyPayment() {
        if (this.error) {
            return false;
        }
        return this.financeProduct.Quote.AllInclusiveRegularPayment;
    }

    getCashDesposit() {
        if (this.error) {
            return false;
        }
        return this.financeProduct.Quote.CashDeposit;
    }

    getDesposit() {
        if (this.error) {
            return false;
        }
        return this.financeProduct.Quote.Deposit;
    }

    getTerm() {
        if (this.error) {
            return false;
        }
        return this.financeProduct.Quote.Term;
    }

    getAnnualMileage() {
        if (this.error) {
            return false;
        }
        return this.financeProduct.Quote.AnnualMileage;
    }

    getDepositContribution() {
        if (this.error) {
            return 0.00;
        }

        let depCon = 0.00;

        if (typeof this.financeProduct.Quote.DepositContributions !== 'undefined') {
            this.financeProduct.Quote.DepositContributions.forEach(element => {
                if (typeof element.Amount !== 'undefined' && element.Amount > 0) {
                    depCon = depCon + parseFloat(element.Amount);
                }
            });
            return depCon;
        }

        if (typeof this.financeProduct.Notifications.Public !== 'undefined') {
            this.financeProduct.Notifications.Public.forEach(financeNotification => {
                if (financeNotification.Code == "9" && financeNotification.Value > 0) {
                    depCon = depCon + financeNotification.Value;
                }
            });
            return depCon;
        }

        return depCon;
    }

    getApr() {
        if (this.error) {
            return false;
        }

        if (typeof this.financeProduct.Quote !== 'undefined' && typeof this.financeProduct.Quote.Apr !== 'undefined') {
            return parseFloat(this.financeProduct.Quote.Apr);
        }

        return false;
    }

    getNumberOfPayments() {
        if (this.error) {
            return false;
        }

        let numberOfPayments = 0;
        if (typeof this.financeProduct.Quote.Payments == 'undefined') {
            return numberOfPayments;
        }

        let paymentsLength = this.financeProduct.Quote.Payments.length;
        if (paymentsLength == 0) {
            return numberOfPayments;
        }

        this.financeProduct.Quote.Payments.forEach((element, index) => {
            if (typeof element.NumberOfPayments == 'undefined') {
                return;
            }
            numberOfPayments = numberOfPayments + parseInt(element.NumberOfPayments);
        });

        return numberOfPayments;
    }

    getFinalPayment() {
        if (this.error) {
            return false;
        }

        if (typeof this.financeProduct.Quote.FinalPayment !== 'undefined') {
            return this.financeProduct.Quote.FinalPayment;
        }

        if (typeof this.financeProduct.Quote.Payments == 'undefined') {
            return 0.00;
        }

        let paymentsLength = this.financeProduct.Quote.Payments.length;
        if (paymentsLength == 0) {
            return 0.00;
        }

        let lastPayment = this.financeProduct.Quote.Payments[paymentsLength - 1];
        if (typeof lastPayment.NumberOfPayments == 'undefined' || lastPayment.NumberOfPayments > 1) {
            return 0.00;
        }
        if (typeof lastPayment.Amount == 'undefined') {
            return 0.00;
        }

        return lastPayment.Amount;
    }

    getFirstFee() {
        if (this.error) {
            return false;
        }

        if (typeof this.financeProduct.Quote.Fees == 'undefined') {
            return 0.00;
        }

        let feesLength = this.financeProduct.Quote.Fees.length;
        if (feesLength == 0) {
            return 0.00;
        }

        let firstFee = this.financeProduct.Quote.Fees[0];
        if (typeof firstFee.Amount == 'undefined') {
            return 0.00;
        }

        return parseFloat(firstFee.Amount);
    }

    getLink() {
        if (this.error) {
            return false;
        }
        if (typeof this.financeProduct.Quote.QuoteLink == 'undefined') {
            return false;
        }
        return this.financeProduct.Quote.QuoteLink;
    }

    getGovernmentGrant() {
        if (this.error) {
            return 0;
        }
        if (typeof this.financeProduct.Quote.CashPriceDiscounts == 'undefined' || this.financeProduct.Quote.CashPriceDiscounts.length == 0) {
            return 0;
        }
        let governmentGrant = 0;
        for (let i = 0, len = this.financeProduct.Quote.CashPriceDiscounts.length; i < len; i++) {
            if (this.financeProduct.Quote.CashPriceDiscounts[i].Name && this.financeProduct.Quote.CashPriceDiscounts[i].Name == 'Government Grant') {
                governmentGrant += this.financeProduct.Quote.CashPriceDiscounts[i].Amount;
            }
        }

        return governmentGrant;
    }

    getRoadsideAssistance() {
        if (this.error) {
            return 0;
        }
        if (typeof this.financeProduct.Quote.Breakdown == 'undefined' || this.financeProduct.Quote.Breakdown.length == 0) {
            return 0;
        }

        let roadsideAssistance = 0;
        for (let i = 0, len = this.financeProduct.Quote.Breakdown.length; i < len; i++) {
            if (this.financeProduct.Quote.Breakdown[i].Type && this.financeProduct.Quote.Breakdown[i].Type == 'Roadside Assistance') {
                roadsideAssistance += this.financeProduct.Quote.Breakdown[i].Amount;
            }
        }

        return roadsideAssistance;
    }
}